import PropTypes from "prop-types";
import { Divider } from "@mui/material";

const ReviewBlock = ({ review, count }) => {
  return (
    <div className="container--user_profile_review">
      { count > 0 ? <Divider variant="middle" light /> : null }
      <div className="text text--user_review">{review}</div>
    </div>
  );
};

export default ReviewBlock;

ReviewBlock.propTypes = {
  review: PropTypes.string,
  count: PropTypes.number,
};